/**
 * Constructor to instanciate when you want to render some integrity data.
 * 
 * @param {string} controller Data integrity controller. See server side for more informations.
 * @return {undefined}
 */
window.DataIntegrityView = function(controller){
	
	this.controller = controller;
	this.$form		= $('#integrity_form');
	this.$renderer	= $('#dataIntegrity-renderer');
	
	DateRangePicker.init('#' + this.$form.attr('id'), false);
	MyForm.prepare(this.$form.attr('id'), this.controller + '&action=process', {
		beforeSend	: this.prepareRender.bind(this),
		success		: this.render.bind(this),
		dataType	: 'json'
	});
	
	return;
};

/**
 * Prepare view between the moment when form is sent and the response received.
 * 
 * @return {undefined}
 */
window.DataIntegrityView.prototype.prepareRender = function(){
	
	this.$renderer.html(MyWindow.getLoader());
	return;
};

/**
 * Render data in view after requesting form submission.
 * 
 * @param {Object} data
 * @return {undefined}
 */
window.DataIntegrityView.prototype.render = function(data){
	
	var renderer_content = '';
	if(MyForm.processJson(data, this.$form.attr('id'))){
		renderer_content = data.html;
	}
	
	this.$renderer.html(renderer_content);
	return;
};
